import { useState } from 'react';
import { Briefcase } from 'lucide-react';

type Props = {
  isOpen: boolean;
  payoutId: number | null;
  amountVnd?: number | null;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
};

export default function PayoutTakeConfirmWidget({ isOpen, payoutId, amountVnd, onClose, onConfirm }: Props) {
  const [loading, setLoading] = useState(false);
  if (!isOpen || payoutId == null) return null;

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await Promise.resolve(onConfirm());
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[240] flex items-center justify-center bg-black/60 dark:bg-black/70 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-700 dark:bg-gray-800">
        <div className="mb-4 flex items-center gap-3">
          <div className="rounded-lg bg-blue-100 p-2 dark:bg-blue-900/30">
            <Briefcase className="h-6 w-6 text-blue-600 dark:text-blue-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Взять выплату в работу</h3>
        </div>
        <p className="mb-5 text-gray-700 dark:text-gray-300">
          Подтвердить взятие выплаты <strong>#{payoutId}</strong> в работу?
        </p>
        {typeof amountVnd === 'number' && amountVnd > 0 ? (
          <div className="mb-5 rounded-xl border border-blue-200 bg-blue-50/70 px-3 py-2 text-sm text-blue-800 dark:border-blue-900/50 dark:bg-blue-900/20 dark:text-blue-300">
            Сумма заявки: <strong>{Math.round(amountVnd).toLocaleString('ru-RU')} VND</strong>
          </div>
        ) : null}
        <div className="flex gap-3">
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 rounded-xl bg-blue-600 px-4 py-2.5 text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? 'Подтверждение…' : 'Да, взять'}
          </button>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="flex-1 rounded-xl bg-gray-200 px-4 py-2.5 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}
